import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { SnUser } from '@lib/api/entities';
import { SnDialogService } from '@lib/ui/dialog';

import { FsPolicyGroup } from '../models';

@Injectable({
  providedIn: 'root',
})
export class FsPolicyGroupService {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _dialogService: SnDialogService,
  ) {}

  public list(params: ISnListQueryParameters): Observable<ISnListResponse<FsPolicyGroup>> {
    return this._httpClient
      .get<ISnListResponse<FsPolicyGroup>>('/api/auth/groups/', { params })
      .pipe(
        map((response) => {
          return {
            ...response,
            results: sortBy(response.results, (i) => i.displayName).map(
              (item) => new FsPolicyGroup(item),
            ),
          };
        }),
      );
  }

  public get(id: string): Observable<FsPolicyGroup> {
    return this._httpClient
      .get<FsPolicyGroup>(`/api/auth/groups/${id}/`)
      .pipe(map((group) => new FsPolicyGroup(group)));
  }

  public create(group: FsPolicyGroup): Observable<FsPolicyGroup> {
    return this._httpClient.post<FsPolicyGroup>('/api/auth/groups/', group);
  }

  public update(id: string, group: FsPolicyGroup): Observable<FsPolicyGroup> {
    return this._httpClient.put<FsPolicyGroup>(`/api/auth/groups/${id}/`, group);
  }

  public delete(id: string): Observable<any> {
    return this._dialogService
      .confirm({
        message: 'users.policyGroups.areYouSureDeleteGroup',
        confirmButton: {
          text: 'common.delete',
          color: 'warn',
        },
      })
      .pipe(
        switchMap(() => {
          return this._httpClient.delete(`/api/auth/groups/${id}/`);
        }),
      );
  }

  public users(id: string, params?: ISnListQueryParameters): Observable<ISnListResponse<SnUser>> {
    return this._httpClient.get<ISnListResponse<SnUser>>(`/api/auth/groups/${id}/users/`, {
      params,
    });
  }

  public setUsers(id: string, users: any[]): Observable<any> {
    return this._httpClient.post(`/api/auth/groups/${id}/users/set/`, { users });
  }
}
